import {filter, reduce, some} from "lodash";
import {IAction} from "@web2/ap-request-state";

import {ADD_ALERT, DROP_TTL_AND_REMOVE, IAddAlertAction, IAlert, IRemoveAlertAction, REMOVE_ALERT} from "./add_remove_alert_action";

export type IAlertsStore = IAlert[];
export interface IAlertsStoreElement {
    alerts: IAlert[];
}

export const alertsReducer = (state: IAlertsStore = [], action: IAddAlertAction | IRemoveAlertAction | IAction): IAlertsStore => {
    switch (action.type) {
        case ADD_ALERT:
            const addAction = action as IAddAlertAction;
            const isDuplicate = some(state, (a) => a.type === addAction.alert.type && a.text === addAction.alert.text);
            return isDuplicate ? state : [...state, addAction.alert];
        case REMOVE_ALERT:
            const removeAction = action as IRemoveAlertAction;
            return filter(state, (alert) => alert.id !== removeAction.id);
        case DROP_TTL_AND_REMOVE:
            return reduce<IAlert, IAlert[]>(
                state,
                (acc, alert) => {
                    if (alert.ttl === -1) {
                        // infinite TTL
                        return [...acc, alert];
                    }
                    // drop TTL by 1 when is high enough
                    if (alert.ttl > 1) {
                        return [...acc, {...alert, ttl: alert.ttl - 1}];
                    }
                    // filter out alert whose TTL is 1 or less
                    return acc;
                },
                []
            );
        default:
            return state;
    }
};
